const filterName = (name: string): string => {
  return name.replace('-', ' ').replace('_', ' ');
};

export const getLinksFromPath = (path: string) => {
  if (!path) {
    return [];
  }

  const links = path
    .split('/')
    .reduce<{ label: string; url: string }[]>((array, x) => {
      if (array.length === 0) {
        return [{ label: 'Home', url: '/' }];
      }

      if (array.length === 1) {
        array.push({ label: filterName(x), url: `/${x}` });
      } else {
        array.push({
          label: filterName(x),
          url: `${array[array.length - 1].url}/${x}`,
        });
      }
      return array;
    }, []);
  return links;
};
